<template>
    <div>
      <div class="overflow-hidden">
        <div class="float-left" style="width: 128px; overflow-y: auto">
          <div class="pt-6" style="min-height: calc(100vh - 135px)">
            <Menu :selectedKeys="[0]"></Menu>
          </div>
        </div>
        <div class="float-right p-6" style="width: calc(100% - 128px)">
          <div class="info">
            <div class="pt-6 step-form-form">
              <a-steps :current="current">
                <a-step title="填写申请资料" />
                <a-step title="金融机构审核" />
                <a-step title="签署合同" />
                <a-step title="支付保费" />
              </a-steps>
            </div>
            <div class="mt-6">
              <div v-show="current === 0">
                <Step1 @next="handleStepNext" ref="step1Ref" />
              </div>
              <div v-show="current === 1">
                <Step2 @next="handleStepNext" @pre="preStepNext" :ct="ct" />
              </div>
              <div v-show="current === 2">
                <Step3 @next="handleStepNext" :ct="ct" />
              </div>
              <div v-show="current === 3">
                <Step4 @next="handleStepNext" :ct="ct" />
              </div>
              <div v-show="current === 4">
                <Step5 @next="handleStepNext" :ct="ct" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    import Menu from '@/views/admin/menu/index';
    import permission from '@/utils/permission';
    import { mapGetters } from 'vuex';
    import Step1 from './stepother/step1.vue';
    import Step2 from './stepother/step2.vue';
    import Step3 from './stepother/step3.vue';
    import Step4 from './stepother/step4.vue';
    import Step5 from './stepother/step5.vue';
    import { contract } from '@/api/contract';
    // import { contract } from '@/api/contract';
    export default {
      components: {
        Menu,
        Step1,
        Step2,
        Step3,
        Step4,
        Step5,
      },
      data() {
        return {
          ct: {},
          current: 0,
          reopen: 0,
        };
      },
      computed: {
        ...mapGetters(['companys']),
        company() {
          return this.companys ? this.companys[0] : {};
        },
      },
      async activated() {
        this.reopen++;
        this.current = 0;
        if (this.$route.params.id != 0) {
          this.ct = (await contract(this.$route.params.id)) || {};
          if (this.ct.status == 4) {
            if (this.ct.is_contract) {
              this.current = 3;
            }
            this.current = 2;
          } else {
            this.current++;
          }
        }
      },
      methods: {
        permission,
        handleStepNext(record) {
          this.ct = record;
          this.current++;
        },
        preStepNext() {
          this.current--;
          this.$refs.step1Ref.preStepupdata(this.ct);
        },
      },
    };
  </script>
  <style scoped>
    .info {
      background: #ffffff;
      min-height: calc(100vh - 276px);
    }
    .step-form-form {
      width: 900px;
      margin: 0 auto 0 auto;
    }
  </style>
  